module.exports = __webpack_public_path__ + "img/gps-locate-me.83c1c469.jpg";